import { useSelectedLeadType } from "modules/LeadsDashboard/hooks";
import { CarsLeads, NotSnoozedLeads, SnoozedLeads, TiresLeads } from "modules/LeadsDashboard/Leads";
import "modules/LeadsDashboard/LeadsDashboard.scss";

export enum LEAD_TYPES {
  Snoozed = 1,
  NotSnoozed,
  Cars,
  Tires
}

const renderLeads = (type: LEAD_TYPES) => {
  switch (type) {
    case LEAD_TYPES.Snoozed:
      return <SnoozedLeads />;

    case LEAD_TYPES.NotSnoozed:
      return <NotSnoozedLeads />;

    case LEAD_TYPES.Tires:
      return <TiresLeads />;

    default:
      return <CarsLeads />;
  }
};

export const LeadsDashboard = () => {
  const selectedLeadType = useSelectedLeadType();

  return <div className="LeadsDashboard">{renderLeads(selectedLeadType)}</div>;
};
